import type { ReactNode } from "react";
import { formatPrice } from "@/helpers/price";

export const euros = (amountCents: number) =>
	formatPrice(amountCents, "EUR", "€");

// FormContainer hides its title when printing; the report's section titles have
// to stay on paper.
export const Section = ({
	title,
	children,
}: {
	title: string;
	children: ReactNode;
}) => (
	<section className="flex flex-col gap-3 print:gap-1 break-inside-avoid">
		<h2 className="border-b pb-2 print:pb-1 print:text-base">{title}</h2>
		{children}
	</section>
);

export const AmountRow = ({
	label,
	detail,
	amountCents,
	isTotal,
}: {
	label: string;
	detail?: string;
	amountCents: number;
	isTotal?: boolean;
}) => (
	<div
		className={`flex justify-between gap-4 ${isTotal ? "font-semibold border-t pt-1" : ""}`}
	>
		<p className={isTotal ? "" : "text-slate-600"}>
			{label}
			{detail && <span className="text-small ml-2">{detail}</span>}
		</p>
		<p className="tabular-nums">{euros(amountCents)}</p>
	</div>
);

export const tableClassName =
	"w-full text-sm print:text-xs [&_th]:text-left [&_th]:font-semibold [&_th]:border-b [&_th]:py-1 [&_td]:py-1 [&_td]:align-top [&_tr]:border-b [&_tr]:border-slate-100";
